import {
  useTheme,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link as RouterLink } from 'react-router-dom';
import React, { useCallback } from 'react';

import { NavSection } from '../models';

interface IProps {
  section: NavSection;
  open?: boolean;
  level?: number;
}

const NavigationSection = ({ section, open = false, level = 0 }: IProps) => {
  const theme = useTheme();

  const getNavSectionProps = useCallback(
    (section: NavSection) =>
      section.href
        ? {
            component: RouterLink,
            to: section.href,
          }
        : {
            onClick: section.onClick,
          },
    []
  );

  return (
    <React.Fragment>
      <ListItem disablePadding>
        <ListItemButton {...getNavSectionProps(section)}>
          <ListItemText
            primary={section.label}
            sx={{ marginLeft: theme.spacing(2 * level) }}
          />
          {section.subsections && section.subsections.length ? (
            <ListItemIcon sx={{ minWidth: 'auto' }}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </ListItemIcon>
          ) : null}
        </ListItemButton>
      </ListItem>
      <Divider />
      {section.subsections && section.subsections.length && open
        ? section.subsections.map((subsection) => (
            <NavigationSection
              level={level + 1}
              key={subsection.key}
              section={subsection}
            />
          ))
        : null}
    </React.Fragment>
  );
};

export default NavigationSection;
